/* eslint-disable max-lines */
import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
// Attempt to import user refresh action if it exists
// If getUsersByID does not exist in your slice, remove or adjust this import.
import { getUsersByID, getWheelPoint } from "../../store/slices/user"; // adjust if path differs

const bucketUrl = process.env.REACT_APP_IMAGE_URL || "https://space.star69.co/";

const SuccessToast = ({ message, show, onClose }) => {
  useEffect(() => {
    if (!show) return;
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: "50%",
        bottom: "86px",
        transform: "translateX(-50%)",
        background:
          "linear-gradient(135deg, rgba(20, 45, 34, 0.95) 0%, rgba(12, 34, 24, 0.95) 100%)",
        border: "1px solid rgba(110, 231, 183, 0.45)",
        borderRadius: "14px",
        padding: "12px 14px",
        width: "min(92vw, 420px)",
        boxShadow:
          "0 14px 34px rgba(0, 0, 0, 0.45), 0 0 20px rgba(16, 185, 129, 0.24)",
        zIndex: 10000,
        animation: "toastPopIn 0.25s ease-out",
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <div
        style={{
          width: 34,
          height: 34,
          borderRadius: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #34d399 0%, #10b981 100%)",
          color: "#062e22",
          fontSize: 18,
          fontWeight: 900,
          flexShrink: 0,
        }}
      >
        💎
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            color: "#a7f3d0",
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 0.3,
            textTransform: "uppercase",
            marginBottom: 1,
          }}
        >
          รับรางวัลสำเร็จ
        </div>
        <div style={{ color: "#ecfdf5", fontWeight: 700, fontSize: 14 }}>
          {message}
        </div>
      </div>
      <button
        onClick={onClose}
        style={{
          background: "none",
          border: "1px solid rgba(167, 243, 208, 0.28)",
          fontSize: "18px",
          cursor: "pointer",
          color: "#d1fae5",
          padding: 0,
          marginLeft: "4px",
          borderRadius: "9px",
          width: "28px",
          height: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "rgba(110, 231, 183, 0.14)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
        }}
      >
        ×
      </button>
      <style>
        {`
          @keyframes toastPopIn {
            from {
              transform: translateX(-50%) translateY(12px) scale(0.98);
              opacity: 0;
            }
            to {
              transform: translateX(-50%) translateY(0) scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

const CounterBonus = ({ variant = "floating" }) => {
  const dispatch = useDispatch();
  const { singleUsers } = useSelector((state) => state.user || {});
  const user = singleUsers && singleUsers.length ? singleUsers[0] : null;
  const isMenuPanel = variant === "menuPanel";

  const [timeLeft, setTimeLeft] = useState("00:00:00");
  const [activeIcon, setActiveIcon] = useState(`${bucketUrl}3d-present.png`);
  const [enableClick, setEnableClick] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "" });
  const giftPendingIcon = `${bucketUrl}3d-stopwatch.png`;
  const giftCloseIcon = `${bucketUrl}3d-present.png`;

  const showSuccessToast = (message) => setToast({ show: true, message });
  const hideToast = () => setToast({ show: false, message: "" });

  // Receive reward
  const handleReceive = async () => {
    if (!enableClick || !user?.id) return;
    setEnableClick(false);
    try {
      const res = await axios.post(
        `https://api.star69.co/countdownbox/receive/${user.id}`,
      );
      if (res?.data?.message === "Diamond Point Added Success") {
        // Refresh user data if action exists
        if (typeof getUsersByID === "function") {
          try {
            dispatch(getUsersByID(user));
            dispatch(getWheelPoint(user));
          } catch (_) {}
        }
        showSuccessToast("รับเพชรฟรีเรียบร้อยแล้ว");
      } else {
        alert("ไม่สามารถรับเพชรได้กรุณาติดต่อแอดมิน");
      }
    } catch (e) {
      console.error(e);
      alert("ไม่สามารถรับเพชรได้กรุณาติดต่อแอดมิน");
    }
  };

  // Countdown logic
  useEffect(() => {
    if (!user?.countdown_end) {
      setTimeLeft("00:00:00");
      setEnableClick(false);
      setActiveIcon(giftCloseIcon);
      return;
    }

    const end = dayjs(user.countdown_end);
    if (!end.isValid()) {
      setTimeLeft("00:00:00");
      setEnableClick(false);
      setActiveIcon(giftCloseIcon);
      return;
    }

    const update = () => {
      const now = dayjs();
      const diff = end.diff(now);
      if (diff <= 0) {
        setTimeLeft("00:00:00");
        setEnableClick(true);
        setActiveIcon(giftCloseIcon);
        return;
      }
      // manual diff breakdown instead of dayjs.duration
      const totalSeconds = Math.floor(diff / 1000);
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
      const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
        2,
        "0",
      );
      const seconds = String(totalSeconds % 60).padStart(2, "0");
      setTimeLeft(`${hours}:${minutes}:${seconds}`);
      setEnableClick(false);
      setActiveIcon(giftPendingIcon);
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [user, giftCloseIcon, giftPendingIcon]);

  // Hidden if no user
  if (!user) return null;

  const themeColor = "#f97316"; // Orange theme color to match

  if (isMenuPanel) {
    const isReady = timeLeft === "00:00:00";

    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 8,
          }}
        >
          <button
            onClick={handleReceive}
            disabled={!enableClick}
            aria-label="receive-bonus"
            style={{
              width: 64,
              height: 64,
              borderRadius: 18,
              border: "1px solid rgba(255,255,255,0.12)",
              background:
                "linear-gradient(145deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.03) 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              overflow: "hidden",
              cursor: enableClick ? "pointer" : "default",
              boxShadow: enableClick
                ? "0 8px 24px rgba(34, 197, 94, 0.25)"
                : "0 4px 16px rgba(0,0,0,0.25)",
              opacity: enableClick ? 1 : 0.95,
              padding: 0,
            }}
          >
            <img
              src={activeIcon}
              alt="bonus-gift"
              draggable={false}
              style={{
                width: 30,
                height: 30,
                objectFit: "cover",
                borderRadius: 8,
                opacity: 0.95,
                position: "absolute",
                top: 7,
              }}
            />
            <span
              style={{
                position: "absolute",
                bottom: 7,
                left: "50%",
                transform: "translateX(-50%)",
                color: isReady ? "#86efac" : "rgba(255,255,255,0.96)",
                fontSize: 10,
                fontWeight: 800,
                fontFamily: "monospace",
                lineHeight: 1,
                textShadow: "0 1px 4px rgba(0,0,0,0.6)",
                whiteSpace: "nowrap",
              }}
            >
              {isReady ? "รับได้แล้ว" : timeLeft}
            </span>
          </button>
          <div
            style={{
              color: "rgba(255,255,255,0.85)",
              fontSize: 11,
              fontWeight: 600,
              lineHeight: 1.25,
              textAlign: "center",
              minHeight: 28,
              display: "flex",
              alignItems: "center",
            }}
          >
            กล่องเพชร
          </div>
        </div>
        <SuccessToast
          message={toast.message}
          show={toast.show}
          onClose={hideToast}
        />
      </>
    );
  }

  return (
    <div
      className="counterbonus-trigger-wrapper"
      style={{
        position: isMenuPanel ? "relative" : "fixed",
        top: isMenuPanel ? "auto" : "125px",
        right: isMenuPanel ? "auto" : 0,
        zIndex: 1000,
        background: isMenuPanel
          ? "linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%)"
          : "linear-gradient(135deg, rgba(30, 30, 50, 0.95) 0%, rgba(20, 20, 35, 0.9) 100%)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        padding: isMenuPanel ? "10px 12px" : "10px 8px 12px",
        borderTopLeftRadius: isMenuPanel ? "14px" : "16px",
        borderBottomLeftRadius: isMenuPanel ? "14px" : "16px",
        borderTopRightRadius: isMenuPanel ? "14px" : 0,
        borderBottomRightRadius: isMenuPanel ? "14px" : 0,
        width: isMenuPanel ? "100%" : "70px",
        display: "flex",
        flexDirection: isMenuPanel ? "row" : "column",
        alignItems: "center",
        justifyContent: isMenuPanel ? "space-between" : "center",
        gap: isMenuPanel ? "10px" : "8px",
        userSelect: "none",
        boxShadow:
          "0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
        transition:
          "transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s ease",
      }}
      onMouseEnter={(e) => {
        if (isMenuPanel) return;
        e.currentTarget.style.transform = "translateX(-4px)";
        e.currentTarget.style.boxShadow =
          "0 12px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.15)";
      }}
      onMouseLeave={(e) => {
        if (isMenuPanel) return;
        e.currentTarget.style.transform = "translateX(0)";
        e.currentTarget.style.boxShadow =
          "0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.1)";
      }}
    >
      {/* Decorative glow */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "-20px",
          width: "40px",
          height: "60px",
          background: `radial-gradient(ellipse, ${themeColor}40 0%, transparent 70%)`,
          transform: "translateY(-50%)",
          pointerEvents: "none",
          filter: "blur(8px)",
        }}
      />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: isMenuPanel ? 10 : 0,
          flex: isMenuPanel ? 1 : "initial",
        }}
      >
        <button
          onClick={handleReceive}
          disabled={!enableClick}
          aria-label="receive-bonus"
          style={{
            border: "none",
            background: "transparent",
            padding: 0,
            cursor: enableClick ? "pointer" : "not-allowed",
            opacity: enableClick ? 1 : 0.7,
            transition:
              "transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.2s ease",
            position: "relative",
          }}
          onMouseEnter={(e) => {
            if (enableClick) {
              e.currentTarget.style.transform = "scale(1.08)";
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          {/* Icon container with gradient border */}
          <div
            style={{
              position: "relative",
              width: "58px",
              height: "58px",
              borderRadius: "16px",
              background: enableClick
                ? `linear-gradient(145deg, ${themeColor}, ${themeColor}88)`
                : "linear-gradient(145deg, #6b7280, #4b5563)",
              padding: "3px",
              boxShadow: enableClick
                ? `0 4px 20px ${themeColor}40, 0 2px 8px rgba(0, 0, 0, 0.3)`
                : "0 4px 20px rgba(107, 114, 128, 0.3), 0 2px 8px rgba(0, 0, 0, 0.3)",
              transition: "all 0.3s ease",
            }}
          >
            <img
              src={activeIcon}
              alt="bonus-gift"
              draggable={false}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "13px",
                display: "block",
                transition: "transform 0.3s ease",
                animation: enableClick
                  ? "bonusBounce 1s ease-in-out infinite"
                  : "none",
              }}
            />
            {/* Shine overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                borderRadius: "16px",
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 50%, transparent 100%)",
                pointerEvents: "none",
              }}
            />
          </div>

          {/* Ready indicator badge */}
          {enableClick && (
            <div
              style={{
                position: "absolute",
                top: "-4px",
                right: "-4px",
                width: "14px",
                height: "14px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #22c55e, #16a34a)",
                border: "2px solid rgba(20, 20, 35, 0.9)",
                boxShadow: "0 2px 8px rgba(34, 197, 94, 0.5)",
                animation: "bonusPulse 2s ease-in-out infinite",
              }}
            />
          )}
        </button>

        {isMenuPanel && (
          <div style={{ minWidth: 0 }}>
            <div
              style={{
                color: "rgba(255,255,255,0.95)",
                fontSize: 13,
                fontWeight: 800,
                lineHeight: 1.2,
              }}
            >
              กล่องเพชรฟรี
            </div>
            <div
              style={{
                color: "rgba(255,255,255,0.65)",
                fontSize: 11,
                marginTop: 2,
              }}
            >
              ครบเวลาแล้วกดรับได้ทันที
            </div>
          </div>
        )}
      </div>

      {/* Timer display */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: isMenuPanel ? "flex-end" : "center",
          gap: "2px",
          minWidth: isMenuPanel ? 74 : "auto",
        }}
      >
        <span
          style={{
            fontSize: "0.8rem",
            fontWeight: 700,
            fontFamily: "monospace",
            color:
              timeLeft === "00:00:00" ? "#22c55e" : "rgba(255,255,255,0.95)",
            textAlign: "center",
            letterSpacing: "0.05em",
            textShadow:
              timeLeft === "00:00:00"
                ? "0 0 8px rgba(34, 197, 94, 0.6)"
                : "0 1px 4px rgba(0, 0, 0, 0.5)",
            animation:
              timeLeft === "00:00:00"
                ? "bonusBlink 1s ease-in-out infinite"
                : "none",
          }}
        >
          {timeLeft}
        </span>
      </div>

      <SuccessToast
        message={toast.message}
        show={toast.show}
        onClose={hideToast}
      />

      <style>
        {`
          @keyframes bonusPulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.15); opacity: 0.85; }
          }
          
          @keyframes bonusBounce {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
          
          @keyframes bonusBlink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.6; }
          }
          
          .counterbonus-trigger-wrapper::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
            border-radius: 16px 16px 0 0;
          }
        `}
      </style>
    </div>
  );
};

export default CounterBonus;
